"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @module validation-regexes
// TODO: figure out if this rule should be disabled globally.
// Escapes are not useless when creating regexp using non-literal notation
/* eslint-disable no-useless-escape */

/**
 * A collection of regexes for user input validation. Based on validation RegExes from the following
 * module by Jasmine Mann <jasminem@zillowgroup.com>:
 * https://stash.atl.zillow.net/projects/FE/repos/static-contact-form/browse/src/static-contact-form/js/ajax-form-ext.js
 */

/**
 * Regular expression that validates a full date in
 * Month + Day + Year (2 or 4 digits) format, with
 * dashes (-) or slashes (/) as delimiters.
 */
var RX_DATE = exports.RX_DATE = /^([1-9]|1[0-2])(\-|\/)([1-9]|[0-2][0-9]|3[0-1])(\-|\/)(\d{4}|\d{2})$/;

/**
 * Regular expression that validates an email address.
 */

// ACC-1141: this is the same regex used by account service when registering users, with
// the addition of maintaining the existing limit of 6 characters for the top level domain
// PR-12442 - opening up top level domain length to 63 to match standards
var RX_EMAIL = exports.RX_EMAIL = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-zA-Z]{2,63}$/i;

// Previous versions:
// /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
// /^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/
// /^([\w]+(?:\.[\w]+)*)@((?:[\w]+\.)*\w[\w]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
// /^([\w]+(?:[_\-\.][\w]+)*)@((?:[\w\-]+\.)*\w[\w\-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
// /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-zA-Z]{2,6}$/i;

/**
 * Validate phone numbers according to the North American Numbering Plan
 *      http://blog.stevenlevithan.com/archives/validate-phone-number#r4-2-v-invalid
 *
 *  - Area codes start with a number from 2-9, followed by 0-8, and then any third digit.
 *  - The second group of three digits, known as the central office or exchange code,
 *    starts with a number from 2-9, followed by any two digits.
 *  - The final four digits, known as the station code, have no restrictions.
 *
 *  - ADDED extension support: a space, then 'x', and at least one but no more than 4 digits
 */
var RX_PHONE = exports.RX_PHONE = /^\(?([2-9][0-8][0-9])\)?[\-. ]?([2-9][0-9]{2})[\-. ]?([0-9]{4})(?: x(\d{1,4}))?$/;

/**
 * Validate international phone numbers according to https://zbrt.zillow.local/browse/PRO-1396
 */
var RX_PHONE_INTL = exports.RX_PHONE_INTL = /^\+?[0123456789 \-\.\(\)]+$/;

/**
 * Regular expression that validates a full clock
 * time value (12-hour clock, with optional seconds).
 */
var RX_TIME = exports.RX_TIME = /^([1-9]|1[0-2]):[0-5]\d(:[0-5]\d(\.\d{1,3})?)?$/;

/**
 * Regular expression that validates a full year value (2012).
 *
 * NOTE: Does not actually validate if it is a _valid_ year,
 * e.g., "0000" is technically valid according to this regex.
 *
 * TODO: Implement RFC-aware validation comparing with Date().
 */
var RX_YEAR = exports.RX_YEAR = /^\d{4}$/;

/**
 * Regular expression that validates a URL with or without a protocol.
 *
 * Taken from z-msg-disallow-url-validator module
 * https://stash.atl.zillow.net/projects/FE/repos/static-email-a-friend/browse/src/static-email-a-friend/js/z-msg-disallow-url-validator/z-msg-disallow-url-validator.js
 * Originially taken from http://blog.mattheworiordan.com/post/13174566389/url-regular-expression-for-links-with-or-without
 */
var RX_URL = exports.RX_URL = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-]*)?\??(?:[\-\+=&;%@\.\w]*)#?(?:[\.\!\/\\\w]*))?)/;